/*
format: {FEATURE_FLAG_NAME}: {VARIABLE_NAME}
*/

export const featureFlagsDict = {
  'app-route-purchases': 'appRoutePurchases',
  'app-route-sales': 'appRouteSales',
  'app-route-contracts': 'appRouteContracts',
  'app-route-inventory': 'appRouteInventory',
  'app-route-customers': 'appRouteCustomers',
  'app-route-commodities': 'appRouteCommodities',
  'app-route-freight': 'appRouteFreight',
  'app-route-ledger': 'appRouteLedger',
  'app-route-analytics': 'appRouteAnalytics',
  'app-route-reports': 'appRouteReports',
  'app-route-assets': 'appRouteAssets',
  'app-route-load-board': 'appRouteLoadBoard',
  'GREEN-4503-show-weight-decimal-setting': 'showWeightDecimalSetting',
  'GREEN-4683-archive-materials': 'canArchiveFlag',
  'GREEN-5063-add-pay-to-section-in-check-printing-modal': 'canChangePayTo',
  'GREEN-5401-validation-for-invoice-po-and-so-number-fields': 'canCustomizeOrderNumbers',
  'GREEN-5458_autofill_material_on_enter_ibt': 'canAutoSelect',
  'GREEN-5506-ibt-status-select': 'showIbtStatusSelect',
  'GREEN-5540-currency-exchange-rates': 'currencyExchangeRatesFF',
  'GREEN-5551-Flag-Manual-Scale-Read-Override': 'canFlagManualScaleReadOverrideFF',
  'GREEN-5575-capture-weights-obt': 'captureWeightsOBTFeatureFlagOn',
  'GREEN-5580-capture-weights-on-ibt-industrial-view': 'captureWeightsIBTFeatureFlagOn',
  'GREEN-5711-check-printing-click-reduction': 'reduceCheckPrintClicks',
  'GREEN-5717_Ledger_Mark_As_Synced': 'canMarkAsSynced',
  'GREEN-5799-show-truck-in-yard-ibt-status': 'enableTruckInYardIBTStatusFeatureFlag',
  'GREEN-6014_upload_docs_to_ibt': 'canUploadFilesIBT',
  'GREEN-6015_upload_docs_to_po': 'canUploadFilesPO',
  'GREEN-6015_upload_docs_to_obt': 'canUploadFilesOBT',
  'GREEN-6017__upload_docs_to_so': 'canUploadFilesSO',
  'GREEN-7708-add-file-upload-component-to-customer-profile': 'canUploadFilesCustomer',
  'GREEN-6045-CSV-price-file-uploads': 'canDownloadAndUploadPrices',
  'GREEN-6109_capture_customer_photo_on_IBT_in_yards_payments': 'canCaptureCustomerPhoto',
  'GREEN-6254-change-um-on-ibt-list': 'canUpdateUm',
  'green-6346-gs-chat': 'gsChatTreatment',
  'GREEN-9834-i18n-explorations': 'canToggleLanguage',
  'GREEN-8812-Metal-Detector': 'canUseMetalDetector',
  'GREEN-6393-minimal-obt': 'useMinimalObt',
  'GREEN-6477_Embed_Metabase_Report_136': 'embedMetabaseReport136',
  'GREEN-6480_Embed_Metabase_Report_137': 'embedMetabaseReport137',
  'GREEN-6880-Date-Range-DPS-Report': 'canSetRangeForDPSReport',
  'GREEN-7040-show-printed-bill-in-inyard-payment': 'showSettlementPrintDocument',
  'GREEN-7717-Show-Notes-from-SO-on-BOL': 'showNotesFromSOOnBOL',
  enable_ibt_autosave: 'enableIbtAutosave',
  show_check_inventory_transfer: 'showCheckInventoryTransfer',
  show_merge_tickets: 'showMergeTickets',
  show_ibt_grid_view: 'showIbtGridView',
  show_decimal_precision_setting: 'showDecimalPrecisionSetting',
  show_payment_rounding_setting: 'showPaymentRoundingSetting',
  'GREEN-7825_Metabase_Report_341_Positive_Pay': 'positivePayReport',
  'GREEN-7161-inventory-overhaul': 'inventoryOverhaul',
  'GREEN-8173-show-20-materials-on-ibt': 'show20MaterialsOnIBTs',
  'GREEN-8091-paginate-ibts': 'paginateIBTs',
  'GREEN-8084-paginate-customers': 'paginateCustomers',
  'GREEN-8215-um-receipts': 'showUnitOnReceipts',
  'GREEN-8026-Enable_Four_Decimal_Precision_In_Inventory': 'enableFourDecimalPrecisionInInventory',
  'GREEN-8012_enable_material_payment_holds': 'enableMaterialPaymentHolds',
  'GREEN-8255-flag-when-ticket-value-is-threshold': 'ticketValueThresholdFlag',
  'GREEN-8614-org-level-reports': 'orgLevelReports',
  'GREEN-8424-enable-display-regrade-information': 'enableDisplayRegradeInformation',
  'GREEN-9258-enable-request-images-v2': 'enableRequestImagesV2',
  'GREEN-6601-support-void-invoice': 'supportVoidInvoice',
  'GREEN-9411-explo-reports': 'enableExploReports',
  'GREEN-6060-custom-check-templates': 'enableCustomCheckTemplates',
  'GREEN-10109-embed-explo-report-builder': 'enableReportBuilder',
  'GREEN-9774-printed-doc-compliance': 'enablePrintedDocCompliance',
  'GREEN-9906-org-level-reports-explo': 'enableOrgLevelExploReports',
  'GREEN-10406-enable-upload-fingerprint': 'enableUploadFingerprint',
  'GREEN-10659-disable-saving-invoices-with-no-tickets': 'disableSavingInvoicesWithNoTickets',
  'enable-pdf-emails': 'enablePdfEmails',
  'GREEN-10689-customer-portal': 'enableCustomerPortal',
  'GREEN-11284-fe-pdfs': 'enableFePdfs',
  'enable-scaleticket-barcode': 'enableScaleTicketBarcode',
  'GREEN-11318-Remove-Zeros': 'removeZerosFF',
  'GREEN-6174-hardware-bundles': 'enableHardwareBundles',
  'GREEN-11314-Commodity-Weight-Thresholds': 'enableCommodityWeightThresholds',
  'inventory-rec-cyclic': 'enableModifiedInventoryRecReport',
  'GREEN-11475-Pull-Apart': 'enablePullApartFeatures',
  'GREEN-11544-revert-dt-from-complete': 'enableRevertFromFinished',
  'GREEN-11549-address-printing': 'enableAddressPrintingUpdates',
  'GREEN-11948-responsive-bol': 'responsiveBOL',
  'GREEN-12034-greenspark-pay': 'enableGreensparkPayFF',
  'GREEN-10498-sales-order-freight-costs': 'enableSalesOrderFreightCosts',
  'GREEN-10786-email-bols-and-pls': 'emailBOLsAndPLs',
  'GREEN-12165-void-recurring-dispatch': 'voidRecurringDt',
  'GREEN-12301-void-ticket-and-recurrence': 'voidTicketAndRecurrence',
  'GREEN-12451-list-asset-result-limit': 'listAssetResultLimit',
  'GREEN-12540-embed-monterrey-accounting-report': 'embedMonterreyAccountingReport',
  'GREEN-12511-handle-multi-location-yards': 'enableMultiLocationYards',
  'GREEN-12331-fees-and-promotions': 'feesAndPromotionsFF',
  'GREEN-12153-Customize-The-IBT-Card-View': 'customizeIbtCardView',
  'outbound-ticket-audit-report': 'enableOutboundTicketAuditReport',
  'GREEN-12154-country-codes': 'enableCountryCodes',
  'GREEN-12068-transfer-tickets-consumer-weights': 'enableTransferTicketsConsumerWeightsFF',
  'GREEN-12495-lock-accounting-v2': 'enableLockAccountingV2',
  'GREEN-12632-dispatch-asset-barcodes': 'enableDispatchAssetBarcodes',
  'GREEN-12466-invoice-API-improvements': 'enableInvoiceContainerV2',
  'geo-map-demo-report': 'enableGeographicMapDemoReport',
  'GREEN-12762-edit-driver-gsuser': 'enableEditDriverGsUser',
  'GREEN-12164-distpatch-ticket-contact': 'enableDispatchContact',
  'GREEN-12343-set-default-tax-rate': 'setDefaultTaxRate',
  'GREEN-12818-scan-license-shortcut': 'enableScanLicenseShortcut',
  'GREEN-12325-so-export': 'enableSoExport',
  'GREEN-8155-enable-batch-bills': 'enableBatchBills',
  'GREEN-12380-intercompany-dispatch': 'enableIntercompanyDispatch',
  'GREEN-13001-new-customer-location-delete': 'enableNewCustomerLocationDelete',
  'GREEN-12347-close-contracts': 'enableAutoCloseContracts',
  'phoenix-bank-file-report': 'enablePhoenixBankFileReport',
  'GREEN-11545-negative-bill-to-invoice': 'enableNegativeIbtToInvoice',
}

// Type for the keys of the object
export type SplitFeatureFlagName = keyof typeof featureFlagsDict
// Type for the values of the object
export type FeatureFlagValue = (typeof featureFlagsDict)[SplitFeatureFlagName]
